module.exports = __webpack_public_path__ + "static/img/RAK_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAK_1.png
// module id = jIqJ
// module chunks = 0